const reviewableStatuses = ['submitted']
const pendingReviewStatusFilterValue = 'submitted'

const createEmptyAcceptForm = () => ({
  comment: '',
})

const hasRequiredDecisionComment = comment => typeof comment === 'string' && comment.trim() !== ''

const buildDecisionPayload = comment => ({
  comment: comment.trim(),
})

const buildAcceptPayload = form => {
  const payload = {}
  const comment = typeof form.comment === 'string' ? form.comment.trim() : ''
  if (comment !== '') {
    payload.comment = comment
  }

  return payload
}

const isReviewableStatus = status => reviewableStatuses.includes(status)

const getExternalOrderRequestStatusVariant = status => {
  if (status === 'accepted') {
    return 'success'
  }
  if (status === 'rejected' || status === 'cancelled') {
    return 'danger'
  }
  if (status === 'changes_requested') {
    return 'warning'
  }
  if (status === 'submitted') {
    return 'info'
  }
  return 'secondary'
}

export {
  buildAcceptPayload,
  buildDecisionPayload,
  createEmptyAcceptForm,
  getExternalOrderRequestStatusVariant,
  hasRequiredDecisionComment,
  isReviewableStatus,
  pendingReviewStatusFilterValue,
  reviewableStatuses,
}
